import React, { ChangeEvent, useEffect, useState } from 'react';
import SystemModal from '../../common/SystemModal';
import ITenantOu from '../../interfaces/ITenantOu';
import { useTranslation } from 'react-i18next';
import { deleteTenantOu } from '../../services/tenant';
import { getValidationNumbers } from '../../utils/numbers';

interface IProps {
  ouData: ITenantOu;
  modalIsOpen: boolean;
  onClose(created: boolean): void;
  showSnackBar(message: string, type: string): void;
}

const ModalDeleteOu = ({ ouData, modalIsOpen, onClose, showSnackBar }: IProps): JSX.Element => {
  const { t: translate } = useTranslation();
  const [validationNumbers, setValidationNumbers] = useState<number[]>(getValidationNumbers());
  const [inputValue, setInputValue] = useState('');
  const [firstNumber, secondNumber] = validationNumbers;
  const validationResult = firstNumber + secondNumber;

  useEffect(() => {
    setValidationNumbers(getValidationNumbers());
    if (!modalIsOpen) {
      setInputValue('');
    }
  }, [modalIsOpen]);

  const _onClose = () => {
    onClose(false);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleDelete = async () => {
    try {
      if (ouData.id) {
        await deleteTenantOu(ouData.id);
        showSnackBar(translate('notification/success_delete'), 'success');
        onClose(true);
      }
    } catch (error) {
      showSnackBar(String(error), 'error');
      console.error(error);
    }
  };

  return (
    <SystemModal modalIsOpen={modalIsOpen} onRequestClose={_onClose}>
      <section className="modal-content modal-delete-registers">
        <header>
          <h2 className="modal-title">{translate('modal/exclude_info_title')}</h2>
        </header>
        <div className="modal-section-content">
          <label className="text-bold">
            {translate('modal/resolve_sum_text')} {firstNumber}+{secondNumber}?
          </label>
          <input value={inputValue} className="form-control" onChange={handleChange} />
        </div>
        <footer>
          <button type="button" onClick={_onClose} className="btn-white-green">
            {translate('modal/exclude_cancel')}
          </button>
          <button
            type="button"
            id="btnConfirm"
            onClick={handleDelete}
            disabled={parseInt(inputValue) !== validationResult}
            className="btn-green">
            {translate('modal/exclude_confirm')}
          </button>
        </footer>
      </section>
    </SystemModal>
  );
};

export default ModalDeleteOu;
